"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChipWithDigitalHig = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
var _cross = _interopRequireDefault(require("@digital-hig/icon/lib/esm/icons/cross"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _excluded = ["className", "disabled", "selected"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var ChipWithDigitalHig = exports.ChipWithDigitalHig = function ChipWithDigitalHig(BaseMuiChip) {
  var Chip = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var className = _ref.className,
      disabled = _ref.disabled,
      selected = _ref.selected,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var muiChipPresets = {
      // avatar,
      // children,
      // classes,
      // clickable,
      // color,
      // component,
      deleteIcon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
        tabIndex: disabled ? -1 : 0
      }, /*#__PURE__*/_react.default.createElement(_cross.default, null)),
      // disabled,
      // icon,
      // label,
      // onDelete,
      // size,
      skipFocusWhenDisabled: true
      // sx,
      // variant
    };
    var classnames = className && className.split(" ") || [];
    selected && classnames.push("DhigChip--selected");
    return /*#__PURE__*/_react.default.createElement(BaseMuiChip, _extends({}, muiChipPresets, {
      className: classnames.join(" "),
      disabled: disabled
    }, otherProps, {
      ref: ref
    }));
  });
  Chip.displayName = "Chip";
  Chip.propTypes = {
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(_constants.availableColors),
    disabled: _propTypes.default.bool,
    selected: _propTypes.default.bool,
    variant: _propTypes.default.oneOf(_constants.availableVariants)
  };
  Chip.defaultProps = {
    color: _constants.colors.DEFAULT,
    disabled: false,
    selected: false,
    variant: _constants.variants.FILLED
  };
  return Chip;
};
var Chip = ChipWithDigitalHig(_Chip.default);
var _default = exports.default = Chip;